<template>
    <div class="t-expert">
        <div v-if="isPending" class="t-expert__loading">
          <div class="ws-list-view-skeleton">
            <ws-list-view-skeleton-item
              :height="'30px'"
              :boxCount="1"
              :boxHeights="['30px']"
            />
            <ws-list-view-skeleton-item
              :height="'25px'"
              :boxCount="1"
              :boxHeights="['25px']"
            />
          </div>
        </div>
        <ws-list-view
          v-else-if="experts && experts.length"
          class="ws-members__list"
          :data="experts"
          :header="false"
          :placeholder="''"
          :skeleton='isPending'
          :detailed="false"
        >
          <template slot-scope="props">
            <ws-list-view-item-column>
              <div class="ws-members__item ws-member">
                <div class="ws-member__column">
                  <figure class="image is-128x128">
                    <ws-avatar
                      v-if="props.row"
                      :id="props.row.guid"
                      :name="getExpertName(props.row)"
                      :size="128"
                    />
                  </figure>
                </div>
                <div class="ws-member__column">
                  <span v-if="props.row">
                    <strong>{{ getExpertName(props.row, true) }}</strong><br>
                    <span class="is-size-5" v-if="props.row.region">{{ props.row.region.title.display }}</span><br>
                    <span class="has-text-primary">{{getExpertEmail(props.row) }}</span><br>
                    <span class="has-text-primary">{{ getPhoneNumbers(props.row) }}</span><br>
                    <ws-demo-exams-certificate-view
                      expertType="linealExpert"
                      :exam_day_cm1="exam.day_cm1"
                      :expert="props.row"
                    />
                    <b-checkbox
                      name="remote"
                      class="b-checkbox__centered"
                      v-if="isRemoteExam"
                      :disabled="isDisabledExpertsInRemote(props.row)"
                      v-model="props.row.is_remote"
                    >
                      <b>{{$t('Дистанционный (удаленный) формат')}}</b>
                      <ws-spinner v-if="isRemotePending(props.row)" />
                    </b-checkbox>
                  </span>
                </div>
                <div class="ws-member__column">
                </div>
                <div class="ws-member__column" style="padding-right: 20px">
                  <div class="buttons" v-if="props.row.isNotLocal === undefined || props.row.isNotLocal">
                    <ws-role-node :only="['front_me', 'front_dep', 'front_admin']">
                      <button
                        v-if="props.row.expert_exam_status !== expertStatus.accepted && isSaved(props.row)"
                        type="button"
                        class="ws-button button is-primary is-small is-uppercase is-fullwidth"
                        :class="{'is-loading':expertsStatusPending.indexOf(props.row.guid) > -1}"
                        @click="acceptExpert(props.row.guid, true)"
                        v-text="$t('Назначить')"
                        :disabled="isActionsDisabled"

                      ></button>
                      <button
                        v-if="props.row.expert_exam_status === expertStatus.accepted && isSaved(props.row)"
                        type="button"
                        class="ws-button button is-danger is-small is-uppercase is-fullwidth"
                        :class="{'is-loading':expertsStatusPending.indexOf(props.row.guid) > -1}"
                        @click="acceptExpert(props.row.guid, false)"
                        v-text="$t('Отменить')"
                        :disabled="isActionsDisabled"

                      ></button>
                    </ws-role-node>
                    <ws-permission-node :resources="['services/de/experts']" :actions="['delete']" effect="display">
                      <button
                        type="button"
                        class="ws-button button is-danger is-small is-uppercase is-fullwidth"
                        @click="deleteExpert(props.row)"
                        :class="{'is-loading': isDeleting}"
                        v-text="$t('Удалить')"
                        :disabled="isActionsDisabled"
                      ></button>
                    </ws-permission-node>
                  </div>
                </div>
              </div>
            </ws-list-view-item-column>
          </template>
        </ws-list-view>
        <p v-else-if="showEmpty" class="has-text-grey">Эксперты не прикреплены</p>
    </div>
</template>

<script>
import { get } from 'lodash-es'
import { mapActions, mapState } from 'vuex'
import WsDemoExamsCertificateView from '../demo-exams/WsDemoExamsCertificateView.vue'
import { constants } from '@/services/constants.service'
import expertStatus from '../demo-exams/data/expertStatusEnum'

export default {
  name: 'WsTechnicalExpertCard',
  components: { WsDemoExamsCertificateView },
  props: {
    experts: {
      type: Array,
      default: () => []
    },
    exam: {
      type: Object,
      default: () => ({})
    },
    isDeleting: {
      type: Boolean,
      default: false
    },
    isMyDeCenter: {
      type: Boolean,
      default: true
    },
    isPending: {
      type: Boolean,
      default: false
    },
    showEmpty: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      expertsIsRemotePending: [],
      expertStatus
    }
  },
  computed: {
    ...mapState('exams', ['expertsStatusPending']),
    ...mapState('authentication', ['currentRole']),
    isRemoteExam () {
      return this.exam.flags.indexOf('remote_experts') > -1
    },
    isExamComplete () {
      return this.exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT ||
        this.exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT_BLOCKED
    },
    isActionsDisabled () {
      if (['front_admin', 'front_rcc'].includes(this.currentRole)) {
        return false
      }
      return !(this.currentRole === 'front_curator' && this.isMyDeCenter) || this.isExamComplete
    }
  },
  methods: {
    ...mapActions('exams', ['updateExpertStatus']),
    isDisabledExpertsInRemote () {
      return (this.exam.status === constants.exam_status.APPROVED_MAIN_EXPERT && this.currentRole === 'front_me')
    },
    isRemotePending (expert) {
      return this.expertsIsRemotePending.indexOf(expert.guid) > -1
    },
    getPhoneNumbers (expert) {
      const phoneNumbers = get(expert, 'profile.contacts.communication.phone') || get(expert, 'user_info.profile.contacts.communication.phone')

      if (phoneNumbers && phoneNumbers.length) {
        return phoneNumbers.reduce((str, number, index) => {
          if (index) {
            str += ' ,'
          }
          str += number.value
          return str
        }, '')
      }
      return null
    },
    getExpertEmail (expert) {
      const email = get(expert, 'email', '') || get(expert, 'user_info.email', '')
      return email
    },
    async acceptExpert (guid, status) {
      const updatedExam = await this.updateExpertStatus([this.exam.guid, guid, status])
      const expert = updatedExam.technical_experts.find(e => e.guid === guid)
      if (expert) {
        const examExpertIndex = this.exam.technical_experts.findIndex(e => e.guid === guid)
        this.experts[examExpertIndex].expert_exam_status = expert.expert_exam_status
      }
      this.$emit('update', updatedExam)
      return updatedExam
    },
    deleteExpert (expert) {
      this.$emit('onDeleteExpert', expert.guid, expert.expertType)
    },
    isSaved (expert) {
      const experts = this.exam.technical_experts || []
      return experts.find(exp => exp.guid === expert.guid)
    },
    getExpertName (expert, isFullName = false) {
      const firstName = get(expert, 'first.display', '') || get(expert, 'user_info.first.display', '')
      const lastName = get(expert, 'last.display', '') || get(expert, 'user_info.last.display', '')
      const middleName = get(expert, 'middle.display', '') || get(expert, 'user_info.middle.display', '')

      if (isFullName) {
        return `${lastName} ${firstName} ${middleName}`
      }
      return `${firstName} ${lastName}`
    }
  }
}
</script>

<style lang='scss' scoped>
.t-expert {
    &__loading {
      position: relative;
      min-height: 100px;
    }
}
</style>
